module.exports = __webpack_public_path__ + "wallet.413e7ea2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/wallet.jpg
// module id = 244
// module chunks = 0